// src/components/audition-booking-wizard/Step3_ScriptScene.jsx
import React from 'react';
import { Button, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { FaFileAlt, FaUber, FaVideo } from 'react-icons/fa';

const Step3_ScriptScene = ({ audition, sceneScript, handleNext, initialLoading }) => {
    if (initialLoading) {
        return (
            <div className="text-center p-5">
                <Spinner className="text-white" animation="border" variant="danger" />
                <p className='text-white mt-3'>Loading your application status...</p>
            </div>
        );
    }
    return (
        <div className="step_3_inside_custom animate-fade-in">
            <Alert variant="success" className="mb-4 text-center py-2">
                <b>Success!</b> Your application has been registered.
            </Alert>

            <Row className="g-4">
                <Col md={12}>
                    <h6 className="text-danger fw-bold text-uppercase mb-3"><FaFileAlt className="me-2" />Story Line</h6>
                    <div className="script-content-box p-3 rounded bg-dark bg-opacity-25 border border-secondary" style={{ minHeight: '200px', maxHeight: '400px', overflowY: 'auto' }}>
                        <div className="script-text-area text-white small"
                            dangerouslySetInnerHTML={{
                                __html: sceneScript.storyLine || audition.storyLine || "No story line details available."
                            }} />
                    </div>
                </Col>
                <Col md={12}>
                    <h6 className="text-danger fw-bold text-uppercase mb-3"><FaUber className="me-2" />Character Sketch</h6>
                    <div className="script-content-box p-3 rounded bg-dark bg-opacity-25 border border-secondary" style={{ minHeight: '200px', maxHeight: '400px', overflowY: 'auto' }}>
                        <div className="script-text-area text-white small"
                            dangerouslySetInnerHTML={{
                                __html: sceneScript.characterSketch || audition.characterSketch || "No character sketch details available."
                            }} />
                    </div>
                </Col>

                <Col md={12}>
                    <h6 className="text-danger fw-bold text-uppercase mb-3"><FaVideo className="me-2" />Audition Script</h6>
                    <div className="script-content-box p-3 rounded bg-dark bg-opacity-25 border border-secondary" style={{ minHeight: '200px', maxHeight: '400px', overflowY: 'auto' }}>
                        <div className="script-text-area text-white small"
                            dangerouslySetInnerHTML={{
                                __html: sceneScript.roleScript || audition.roleScript || "No script details provided."
                            }} />
                    </div>
                </Col>
            </Row>

            <div className="text-center mt-5">
                <Button variant="danger" className="px-5 py-2 fw-bold rounded-pill shadow" onClick={handleNext}>
                    {audition.auditionType.includes('online') ? 'READY TO RECORD' : 'PROCEED TO DETAILS'}
                </Button>
            </div>
        </div>
    );
};

export default Step3_ScriptScene;